export default __webpack_public_path__ + "static/media/hr-grade.a3b3bc19.png";